<template>
  <div>
    <!--Label-->
    <label
      v-if="label"
      class="block mb-1 text-sm"
      :for="id"
    >
      <span v-html="label" />
    </label>

    <!--Input-->
    <input
      :id="id"
      ref="inputRef"
      :value="modelValue"
      :type="type"
      :autocomplete="autocomplete"
      :required="required"
      :placeholder="placeholder"
      :disabled="disabled || loading"
      class="w-full h-full px-3 py-2 leading-tight border rounded shadow appearance-none focus:ring-4 focus:outline-none focus:ring-primary focus:ring-opacity-25 focus:border-1 focus:border-primary-light text-dark-900 border-dark-300"
      :class="computedClasses"
      :maxlength="maxlength"
      @input="onInput"
    >

    <!--Error Text-->
    <div
      v-if="error"
      class="mt-2 text-xs italic error-text text-error"
      v-html="errorText"
    />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'

const props = defineProps({
  id: {
    type: String,
    default: ''
  },
  autocomplete: {
    type: String,
    default: ''
  },
  required: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: ''
  },
  modelValue: {
    type: String,
    default: ''
  },
  label: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'text'
  },
  error: {
    type: Boolean,
    default: false
  },
  errorText: {
    type: String,
    default: ''
  },
  maxlength: {
    type: Number,
    default: undefined
  }
});

const emit = defineEmits(['update:modelValue', 'input']);
const inputRef = ref(null)

const onInput = (event) => {
  emit('update:modelValue', event.target.value)
  emit('input', event.target.value)
}

const computedClasses = computed(() => {
  const classes = [];
  if (props.error) {
    classes.push("ring-4 ring-opacity-25 ring-error-light border-error");
  } else {
    classes.push('border-none');
  }

  if (props.disabled) {
    classes.push('disabled:cursor-not-allowed disabled:border-dark-200 disabled:bg-dark-50 disabled:text-dark-500');
  }

  return classes.join(' ');
});


</script>

<style scoped>
.error-text a{text-decoration:underline}
</style>
